import { InjectionToken, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrimaryButtonComponent } from './components/atoms/primary-button/primary-button.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { InputComponent } from './components/atoms/input/input.component';
import { CircleComponent } from './components/atoms/circle/circle.component';
import { StepComponent } from './components/atoms/step/step.component';
import { StepsComponent } from './components/molecules/steps/steps.component';
import { CarouselComponent } from './components/organisms/carousel/carousel.component';
import { ParagraphComponent } from './components/atoms/paragraph/paragraph.component';
import { EpsonLogoComponent } from './components/atoms/epson-logo/epson-logo.component';
import { AnchorComponent } from './components/atoms/anchor/anchor.component';
import { RouterModule } from '@angular/router';
import { OnboardingComponent } from './components/templates/onboarding/onboarding.component';
import { LoginComponent } from './components/templates/login/login.component';
import { LabelComponent } from './components/atoms/label/label.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CarouselRegisterComponent } from './components/organisms/carousel-register/carousel-register.component';
import { RegisterComponent } from './components/templates/register/register.component';
import { EpsonPoweredComponent } from './components/atoms/epson-powered/epson-powered.component';
import { BusinessDataFormComponent } from './components/molecules/business-data-form/business-data-form.component';
import { ImageUploadComponent } from './components/molecules/image-upload/image-upload.component';
import { SelectComponent } from './components/atoms/select/select.component';
import { HeaderComponent } from './components/molecules/header/header.component';
import { BusinessEquipmentFormComponent } from './components/molecules/business-equipment-form/business-equipment-form.component';
import { IconButtonComponent } from './components/atoms/icon-button/icon-button.component';
import { BusinessRepresentativeFormComponent } from './components/molecules/business-representative-form/business-representative-form.component';
import { VerificationComponent } from './components/templates/verification/verification.component';
import { MainHeaderComponent } from './components/molecules/main-header/main-header.component';
import { CodeInputComponent } from './components/atoms/code-input/code-input.component';
import { DialogModalComponent } from './components/molecules/dialog-modal/dialog-modal.component';
import { AuthInterceptor } from './guards/auth.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { UserStatusGuard } from './guards/userStatusGuard';
import { ChangePasswordComponent } from './components/templates/change-password/change-password.component';
import { ExpansionPanelComponent } from './components/molecules/expansion-panel/expansion-panel.component';
import { UserHeaderComponent } from './components/organisms/user-header/user-header.component';
import { ProfileMenuComponent } from './components/molecules/profile-menu/profile-menu.component';
import { CheckboxComponent } from './components/molecules/checkbox/checkbox.component';
import { SidenavContentComponent } from './components/organisms/sidenav-content/sidenav-content.component';
import { SideMenuComponent } from './components/molecules/side-menu/side-menu.component';
import { SidemenuItemComponent } from './components/atoms/sidemenu-item/sidemenu-item.component';
import { SidenavService } from '../core/services/sidenav/sidenav.service';
import { LabelPromptButtonComponent } from './components/molecules/label-prompt-button/label-prompt-button.component';
import { RepresentativeItemComponent } from './components/molecules/representative-item/representative-item.component';
import { RepresentativeListComponent } from './components/organisms/representative-list/representative-list.component';
import { InviteComponent } from './components/templates/invite/invite.component';
import { CreateAccountComponent } from './components/templates/create-account/create-account.component';
import { ProfileCreatedComponent } from './components/templates/profile-created/profile-created.component';
import { RoundedImageComponent } from './components/atoms/rounded-image/rounded-image.component';
import { InviteExistingComponent } from './components/templates/invite-existing/invite-existing.component';
import { BusinessChangeComponent } from './components/molecules/business-change/business-change.component';
import { ConfirmedMembershipComponent } from './components/templates/confirmed-membership/confirmed-membership.component';
import { CouponCardComponent } from './components/molecules/coupon-card/coupon-card.component';
import { ProductCouponContentComponent } from './components/organisms/product-coupon-content/product-coupon-content.component';
import { NavigationBarComponent } from './components/molecules/navigation-bar/navigation-bar.component';
import { FormFeedbackListComponent } from './components/organisms/form-feedback-list/form-feedback-list.component';
import { FormFeedbackItemComponent } from './components/molecules/form-feedback-item/form-feedback-item.component';
import { RewardCardComponent } from './components/molecules/reward-card/reward-card.component';
import { StickerIconComponent } from './components/atoms/sticker-icon/sticker-icon.component';
import { IconClickComponent } from './components/atoms/icon-click/icon-click.component';
import { SecondaryButtonComponent } from './components/atoms/secondary-button/secondary-button.component';
import { OpportunityGridComponent } from './components/organisms/opportunity-grid/opportunity-grid.component';
import { RewardDetailsComponent } from './components/organisms/reward-details/reward-details.component';
import { ScoreAreaComponent } from './components/molecules/score-area/score-area.component';
import { ChipComponent } from './components/atoms/chip/chip.component';
import { FilterAreaComponent } from './components/organisms/filter-area/filter-area.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { HeaderContentFooterComponent } from './components/templates/header-content-footer/header-content-footer.component';
import { PointsRescueComponent } from './components/organisms/points-rescue/points-rescue.component';
import { NgxMaskModule } from 'ngx-mask';
import { ImageCropperModule } from 'ngx-image-cropper';
import { MonthExpansionPanelComponent } from './components/molecules/month-expansion-panel/month-expansion-panel.component';
import { TimelineComponent } from './components/organisms/timeline/timeline.component';
import { PointsSummaryComponent } from './components/molecules/points-summary/points-summary.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { PointBalanceComponent } from './components/organisms/point-balance/point-balance.component';
import { TransactionCardComponent } from './components/molecules/transaction-card/transaction-card.component';
import { MatTableModule } from '@angular/material/table';
import { MatChipsModule } from '@angular/material/chips';
import { TransactionCardExpandedComponent } from './components/molecules/transaction-card-expanded/transaction-card-expanded.component';
import { CreateReportModalComponent } from './components/molecules/create-report-modal/create-report-modal.component';
import { MatNativeDateModule } from '@angular/material/core';
import { FilterDateModalComponent } from './components/molecules/filter-date-modal/filter-date-modal.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { QuickMenuComponent } from './components/molecules/quick-menu/quick-menu.component';
import { QuickMenuItemComponent } from './components/atoms/quick-menu-item/quick-menu-item.component';
import { RewardsListComponent } from './components/organisms/rewards-list/rewards-list.component';
import { RewardCardSlimComponent } from './components/molecules/reward-card-slim/reward-card-slim.component';
import { TopHeaderDesktopComponent } from './components/organisms/top-header-desktop/top-header-desktop.component';
import { SideMenuDesktopComponent } from './components/organisms/side-menu-desktop/side-menu-desktop.component';
import { ThrottleClickDirective } from './directives/throttle-click/throttle-click.directive';
import { CouponsListComponent } from './components/organisms/coupons-list/coupons-list.component';
import { SnackBarComponent } from './components/molecules/snackbar/snackbar.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { CouponCardSlimComponent } from './components/molecules/coupon-card-slim/coupon-card-slim.component';
import { IconParagraphComponent } from './components/organisms/icon-paragraph/icon-paragraph.component';
import { AccountSettingsTabGroupComponent } from './components/organisms/account-settings-tab-group/account-settings-tab-group.component';
import { MatTabsModule } from '@angular/material/tabs';
import { EditAccountComponent } from './components/organisms/edit-account/edit-account.component';
import { EditSettingsComponent } from './components/organisms/edit-settings/edit-settings.component';
import { ChangeKnownPasswordComponent } from './components/organisms/change-known-password/change-known-password.component';
import { DeleteAccountComponent } from './components/organisms/delete-account/delete-account.component';
import { TestComponent } from './components/testing/test-component/test-component.component';
import { DeleteRequestProgramEvalModalComponent } from './components/molecules/delete-request-program-eval-modal/delete-request-program-eval-modal.component';
import { AccountDeletedComponent } from './components/organisms/account-deleted/account-deleted.component';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { EmptyFeedComponent } from './components/molecules/empty-feed/empty-feed.component';

import { ExpiredInviteComponent } from './components/organisms/expired-invite/expired-invite.component';
import {
  RECAPTCHA_LANGUAGE,
  RECAPTCHA_SETTINGS,
  RecaptchaFormsModule,
  RecaptchaModule,
  RecaptchaSettings,
  RECAPTCHA_NONCE,
} from 'ng-recaptcha';
import { environment } from 'src/environments/environment';
import { RecaptchaComponent } from './components/molecules/recaptcha/recaptcha.component';
import { CouponCardSlimVipComponent } from './components/molecules/coupon-card-slim-vip/coupon-card-slim-vip.component';
import { ProductCouponVipContentComponent } from './components/organisms/product-coupon-vip-content/product-coupon-vip-content.component';
import { CouponCardVipComponent } from './components/molecules/coupon-card-vip/coupon-card-vip.component';
import { CSP_NONCE_INJECTION_TOKEN } from '../custom-dom-shared-styles-host.service';
import { HeaderMenuComponent } from './components/molecules/header-menu/header-menu.component';
import { FooterOnboardingComponent } from './components/molecules/footer-onboarding/footer-onboarding.component';
import { JoinOnboardingComponent } from './components/molecules/join-onboarding/join-onboarding.component';
import { WelcomeOnboardingComponent } from './components/molecules/welcome-onboarding/welcome-onboarding.component';
import { NoticeModalComponent } from './components/molecules/notice-modal/notice-modal.component';
import { BannerNotificationComponent } from './components/molecules/banner-notification/banner-notification.component';
import { BusinessEquipmentTupleComponent } from './components/molecules/business-equipment-tuple/business-equipment-tuple.component';
import { NbIconModule, NbStatusService } from '@nebular/theme';
import { FilterContainerComponent } from './components/organisms/filter-container/filter-container.component';
import { DateTabSelectorComponent } from './components/molecules/date-tab-selector/date-tab-selector.component';
import { PointBalanceListComponent } from './components/organisms/point-balance-list/point-balance-list.component';

export const WINDOW = new InjectionToken<Window>('Window');

@NgModule({
  declarations: [
    PrimaryButtonComponent,
    IconButtonComponent,
    InputComponent,
    CircleComponent,
    StepComponent,
    StepsComponent,
    CarouselComponent,
    ParagraphComponent,
    InputComponent,
    EpsonLogoComponent,
    AnchorComponent,
    OnboardingComponent,
    LoginComponent,
    LabelComponent,
    CarouselRegisterComponent,
    RegisterComponent,
    EpsonPoweredComponent,
    BusinessDataFormComponent,
    BusinessEquipmentFormComponent,
    BusinessRepresentativeFormComponent,
    FilterContainerComponent,
    ImageUploadComponent,
    SelectComponent,
    HeaderComponent,
    VerificationComponent,
    MainHeaderComponent,
    CodeInputComponent,
    DialogModalComponent,
    CreateReportModalComponent,
    ChangePasswordComponent,
    HeaderContentFooterComponent,
    UserHeaderComponent,
    ExpansionPanelComponent,
    ProfileMenuComponent,
    CheckboxComponent,
    SidenavContentComponent,
    SideMenuComponent,
    SidemenuItemComponent,
    LabelPromptButtonComponent,
    RepresentativeItemComponent,
    RepresentativeListComponent,
    InviteComponent,
    CreateAccountComponent,
    ProfileCreatedComponent,
    RoundedImageComponent,
    InviteExistingComponent,
    BusinessChangeComponent,
    ConfirmedMembershipComponent,
    CouponCardComponent,
    ProductCouponContentComponent,
    NavigationBarComponent,
    FormFeedbackListComponent,
    FormFeedbackItemComponent,
    RewardCardComponent,
    StickerIconComponent,
    IconClickComponent,
    SecondaryButtonComponent,
    OpportunityGridComponent,
    RewardDetailsComponent,
    ScoreAreaComponent,
    ChipComponent,
    FilterAreaComponent,
    TransactionCardComponent,
    PointsSummaryComponent,
    PointsRescueComponent,
    MonthExpansionPanelComponent,
    TimelineComponent,
    PointBalanceComponent,
    PointBalanceListComponent,
    TransactionCardComponent,
    TransactionCardExpandedComponent,
    QuickMenuComponent,
    QuickMenuItemComponent,
    FilterDateModalComponent,
    RewardsListComponent,
    RewardCardSlimComponent,
    TopHeaderDesktopComponent,
    SideMenuDesktopComponent,
    ThrottleClickDirective,
    CouponsListComponent,
    SnackBarComponent,
    CouponCardSlimComponent,
    IconParagraphComponent,
    AccountSettingsTabGroupComponent,
    EditAccountComponent,
    EditSettingsComponent,
    ChangeKnownPasswordComponent,
    DeleteAccountComponent,
    TestComponent,
    DeleteRequestProgramEvalModalComponent,
    DialogModalComponent,
    AccountDeletedComponent,
    EmptyFeedComponent,
    ExpiredInviteComponent,
    RecaptchaComponent,
    CouponCardSlimVipComponent,
    ProductCouponVipContentComponent,
    CouponCardVipComponent,
    HeaderMenuComponent,
    FooterOnboardingComponent,
    JoinOnboardingComponent,
    WelcomeOnboardingComponent,
    NoticeModalComponent,
    BannerNotificationComponent,
    BusinessEquipmentTupleComponent,
    DateTabSelectorComponent,
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatIconModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatCheckboxModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatExpansionModule,
    MatMenuModule,
    MatSidenavModule,
    CarouselModule,
    NgxMaskModule.forRoot(),
    ImageCropperModule,
    InfiniteScrollModule,
    MatCardModule,
    MatTableModule,
    MatChipsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatTabsModule,
    MatRadioModule,
    TranslocoModule,
    RecaptchaFormsModule,
    RecaptchaModule,
    NbIconModule,
    TranslocoModule,
  ],
  exports: [
    PrimaryButtonComponent,
    IconButtonComponent,
    InputComponent,
    CircleComponent,
    ParagraphComponent,
    StepComponent,
    StepsComponent,
    CarouselComponent,
    EpsonLogoComponent,
    AnchorComponent,
    OnboardingComponent,
    LoginComponent,
    LabelComponent,
    CarouselRegisterComponent,
    RegisterComponent,
    EpsonPoweredComponent,
    BusinessDataFormComponent,
    BusinessEquipmentFormComponent,
    BusinessRepresentativeFormComponent,
    FilterContainerComponent,
    ImageUploadComponent,
    SelectComponent,
    HeaderComponent,
    MainHeaderComponent,
    VerificationComponent,
    CodeInputComponent,
    DialogModalComponent,
    CreateReportModalComponent,
    ChangePasswordComponent,
    UserHeaderComponent,
    HeaderContentFooterComponent,
    ExpansionPanelComponent,
    SidenavContentComponent,
    SideMenuComponent,
    SidemenuItemComponent,
    RepresentativeItemComponent,
    RepresentativeListComponent,
    InviteComponent,
    CreateAccountComponent,
    ProfileCreatedComponent,
    RoundedImageComponent,
    LabelPromptButtonComponent,
    InviteExistingComponent,
    BusinessChangeComponent,
    ConfirmedMembershipComponent,
    CouponCardComponent,
    ProductCouponContentComponent,
    NavigationBarComponent,
    FormFeedbackListComponent,
    RewardCardComponent,
    StickerIconComponent,
    IconClickComponent,
    SecondaryButtonComponent,
    OpportunityGridComponent,
    RewardDetailsComponent,
    ScoreAreaComponent,
    ChipComponent,
    FilterAreaComponent,
    PointsSummaryComponent,
    PointsRescueComponent,
    MonthExpansionPanelComponent,
    TimelineComponent,
    PointBalanceComponent,
    PointBalanceListComponent,
    TransactionCardComponent,
    QuickMenuComponent,
    QuickMenuItemComponent,
    RewardsListComponent,
    TopHeaderDesktopComponent,
    SideMenuDesktopComponent,
    CouponsListComponent,
    AccountSettingsTabGroupComponent,
    EditAccountComponent,
    EditSettingsComponent,
    ChangeKnownPasswordComponent,
    DeleteAccountComponent,
    DialogModalComponent,
    AccountDeletedComponent,
    EmptyFeedComponent,
    ExpiredInviteComponent,
    CheckboxComponent,
    RecaptchaComponent,
    ProductCouponVipContentComponent,
    HeaderMenuComponent,
    FooterOnboardingComponent,
    JoinOnboardingComponent,
    WelcomeOnboardingComponent,
    BannerNotificationComponent,
  ],
  providers: [
    UserStatusGuard,
    SidenavService,
    MatDatepickerModule,
    NbStatusService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: environment.recaptcha.siteKey,
      } as RecaptchaSettings,
    },
    {
      provide: RECAPTCHA_LANGUAGE,
      useFactory: (translocoService: TranslocoService) =>
        translocoService.getActiveLang(),
      deps: [TranslocoService],
    },
    {
      provide: RECAPTCHA_NONCE,
      useExisting: CSP_NONCE_INJECTION_TOKEN,
    },
    { provide: WINDOW, useValue: window },
  ],
})
/**
 * Shared module that enables reuse of artifacts, such as components
 */
export class SharedModule {}
